import { useRef } from 'react';
import { ParticleSystem } from '@lili/lili-frontend-common';
import { useResizeListener } from '@Hooks/custom/useResizeListener.ts';
import './SuccessLayoutWrapper.css';
import type React from 'react';

interface SuccessLayoutWrapperProps {
  children: React.ReactNode;
  cardClassName?: string;
}

export const SuccessLayoutWrapper = ({
  children,
  cardClassName = '',
}: SuccessLayoutWrapperProps) => {
  const mobileContainerRef = useRef<HTMLDivElement>(null);
  const desktopContainerRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useResizeListener();

  return (
    <>
      {isMobile ? (
        <div
          data-testid='success-layout-mobile'
          className='h-full w-full bg-surface-primary-bw-00 flex flex-col relative overflow-hidden'>
          <div ref={mobileContainerRef} className='h-full w-full flex flex-col relative'>
            <ParticleSystem containerRef={mobileContainerRef} />
            {children}
          </div>
        </div>
      ) : (
        <div
          data-testid='success-layout-desktop'
          className='flex bg-web-app-blurred h-full w-full bg-cover bg-center items-center justify-center'>
          <div
            ref={desktopContainerRef}
            className={`w-[992px] h-[608px] rounded-[20px] flex flex-col items-center justify-center gap-[0] p-[15px] pt-[71px] relative bg-surface-primary-bw-00 ${cardClassName}`}>
            <ParticleSystem containerRef={desktopContainerRef} />
            {children}
          </div>
        </div>
      )}
    </>
  );
};
